// src/data/comedians/whoopi-goldberg.js

const base = {
  id: 'whoopi-goldberg',
  slug: 'whoopi-goldberg',
  name: 'Whoopi Goldberg',
  birthYear: 1955,
  image: require('@/assets/images/img_Whoopi_Goldberg.jpg'),
  famousWorks: [
    'The Color Purple (1985)',
    'Ghost (1990)',
    'Sister Act series',
    'Star Trek: The Next Generation',
    'The View (2007–present)',
    'Whoopi Goldberg: Direct from Broadway (1985)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'EGOT winner and comedy trailblazer',
    bio: `Whoopi Goldberg is an American actor, comedian, author, and television personality who has achieved EGOT status — winning an Emmy, Grammy, Oscar, and Tony Award. She is one of the few entertainers to have won all four major American entertainment awards.\n\nBorn Caryn Johnson in New York City, she adopted the stage name Whoopi Goldberg and began performing comedy in San Francisco. Her one-woman show caught the attention of Steven Spielberg, who cast her in "The Color Purple" (1985), earning her an Academy Award nomination.\n\nGoldberg won the Oscar for Best Supporting Actress for "Ghost" (1990). Since 2007 she has been a co-host of "The View", where she continues to share perspectives on politics and social issues. Her career spans stand-up, film, television, Broadway, and writing.`,
    style: 'Character-based, socially conscious, versatile, warm and intelligent',
    achievements: [
      'Academy Award for Best Supporting Actress',
      'Grammy Award',
      'Tony Award',
      'Emmy Awards (multiple)',
      'EGOT winner',
      'Mark Twain Prize for American Humor (2001)',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américaine',
    shortBio: 'Gagnante de l\'EGOT et pionnière de la comédie',
    bio: `Whoopi Goldberg est une actrice, comédienne, auteure et personnalité télévisuelle américaine qui a atteint le statut EGOT en remportant un Emmy, un Grammy, un Oscar et un Tony Award. Elle est l'une des rares artistes à avoir remporté les quatre plus grands prix du divertissement américain.\n\nNée Caryn Johnson à New York, elle adopte le nom de scène Whoopi Goldberg et commence la comédie à San Francisco. Son spectacle solo attira l'attention de Steven Spielberg, qui la choisit pour "La Couleur pourpre" (1985).\n\nElle remporte l'Oscar de la meilleure actrice dans un second rôle pour "Ghost" (1990). Depuis 2007, elle est co-animatrice de "The View". Sa carrière couvre le stand-up, le cinéma, la télévision, Broadway et l'écriture.`,
    style: 'Basée sur les personnages, socialement consciente, polyvalente, chaleureuse et intelligente',
    achievements: [
      'Oscar de la meilleure actrice dans un second rôle',
      'Grammy Award',
      'Tony Award',
      'Plusieurs Emmy Awards',
      'Gagnante de l\'EGOT',
      'Mark Twain Prize for American Humor (2001)',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americana',
    shortBio: 'Ganadora del EGOT y pionera de la comedia',
    bio: `Whoopi Goldberg es una actriz, comediante, autora y personalidad televisiva estadounidense que ha conseguido el estatus EGOT al ganar un Emmy, Grammy, Oscar y Tony Award. Es una de las pocas artistas en haber ganado los cuatro grandes premios del entretenimiento americano.\n\nNacida Caryn Johnson en Nueva York, adoptó el nombre artístico Whoopi Goldberg y comenzó la comedia en San Francisco. Su espectáculo en solitario captó la atención de Steven Spielberg, quien la eligió para "El color púrpura" (1985).\n\nGanó el Oscar a la Mejor Actriz de Reparto por "Ghost" (1990). Desde 2007 es copresentadora de "The View". Su carrera abarca stand-up, cine, televisión, Broadway y escritura.`,
    style: 'Basada en personajes, socialmente consciente, versátil, cálida e inteligente',
    achievements: [
      'Oscar a la Mejor Actriz de Reparto',
      'Grammy Award',
      'Tony Award',
      'Múltiples Emmy Awards',
      'Ganadora del EGOT',
      'Mark Twain Prize for American Humor (2001)',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكية',
    shortBio: 'الفائزة بـ EGOT ورائدة الكوميديا',
    bio: `وهوبي غولدبرغ ممثلة وكوميدية وكاتبة وشخصية تلفزيونية أمريكية حقّقت مكانة EGOT بفوزها بجوائز Emmy وGrammy وOscar وTony. وهي واحدة من القلة الذين أحرزوا الجوائز الأربع الكبرى في الترفيه الأمريكي.\n\nوُلدت تحت اسم كارين جونسون في نيويورك، واتخذت اسم وهوبي غولدبرغ فنيًّا وبدأت مسيرتها الكوميدية في سان فرانسيسكو. استوقف عرضها المنفرد المخرج ستيفن سبيلبرغ الذي اختارها لفيلم "The Color Purple" (1985).\n\nفازت بجائزة الأوسكار لأفضل ممثلة مساعدة عن فيلم "Ghost" (1990). ومنذ عام 2007 تشارك في تقديم برنامج "The View". تمتد مسيرتها لتشمل الستاند أب والسينما والتلفزيون وبرودواي والكتابة.`,
    style: 'كوميديا قائمة على الشخصيات، واعية اجتماعيًا، متعددة المواهب، دافئة وذكية',
    achievements: [
      'جائزة الأوسكار لأفضل ممثلة مساعدة',
      'جائزة Grammy',
      'جائزة Tony',
      'عدة جوائز Emmy',
      'فائزة بلقب EGOT',
      'جائزة مارك توين للفكاهة الأمريكية (2001)',
    ],
  },
];
